import deepEqual from 'fast-deep-equal'
import GTM from 'react-gtm-module'
import config from 'config'
import { selectAccount } from 'selectors/app/selectAccount'
import selectCurrentUser from 'ducks/currentUser/selectors/selectCurrentUser'

export const DATA_LAYER_NAME = 'PageDataLayer'

function generateDeferredPromise() {
  let resolve
  let reject
  const promise = new Promise((res, rej) => {
    ;[resolve, reject] = [res, rej]
  })
  return { promise, reject, resolve }
}

export function initializeTracking() {
  // Initialize Google Tag Manager
  const tagManagerArgs = {
    gtmId: config.gtm_containerid,
    auth: config.gtm_auth,
    preview: config.gtm_preview,
    dataLayerName: DATA_LAYER_NAME,
  }
  GTM.initialize(tagManagerArgs)
}

let lastData = null
export function trackPage(
  pageType,
  pageGroup = '',
  userId = '',
  segment = config.gtm_segment,
  version = config.gtm_version,
  event = 'groove_nav_event'
) {
  if (!pageType) {
    throw new Error(
      'pageType, pageGroup, segment and version is required to track a page load'
    )
  }

  if (!window[DATA_LAYER_NAME]) {
    return Promise.resolve()
  }

  const data = {
    segment,
    version,
    pageType,
    pageGroup,
    event,
    userId,
  }

  if (app?.store?.getState) {
    // Not great to access the store like this, but its the lesser evil for now
    const state = app.store.getState()
    const { email, confirmedAt } = selectCurrentUser(state)
    const { subdomain } = selectAccount(state)

    if (email) data.agentEmail = email
    if (confirmedAt) data.userSignupDate = confirmedAt
    if (subdomain) data.accountSubdomain = subdomain
  }

  // All tracking in this module is "page" level tracking. You cant
  // fire the same page tracking twice because pages cant "navigate" to
  // themselves
  if (!deepEqual(lastData, data)) {
    lastData = data
    return dataLayer(data)
  }

  return Promise.resolve()
}

export function dataLayer(data) {
  const dfd = generateDeferredPromise()
  let resolved = false
  // uBlock and other ad-blockers screw with eventCallback in a way that
  // prevents the eventTimeout from triggering the event callback, which
  // completely breaks the whole point of having the stupid timeout in the
  // first place. So, we have to create our own timeout instead.
  setTimeout(() => {
    if (!resolved) {
      resolved = true
      dfd.resolve()
    }
  }, 2000)
  GTM.dataLayer(
    {
      dataLayer: {
        ...data,
        eventCallback: id => {
          // Another container ID is calling this for some reason, so we want
          // to ensure that we are only firing on the right container.
          if (id === config.gtm_containerid) {
            resolved = true
            dfd.resolve()
          }
        },
      },
      dataLayerName: DATA_LAYER_NAME,
    },
    DATA_LAYER_NAME
  )
  return dfd.promise
}
